import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import swal from 'sweetalert2';
import axios from '../../../../../axios-instance';
import withReactContent from 'sweetalert2-react-content';
import ls from 'localstorage-slim';

import NewLoader from "../../../../../components/NewLoader/NewLoader";

import styles from './EventPaymentMethods.module.sass';
import { getCustomURLs } from "../../../../../helpers/getCustomURLs";
import { getHeaders } from "../../../../../helpers/getHeaders";
import CheckBox from "../../../../../components/UI/Checkbox/CheckBox";
import { paymentProvidersOptions } from "../../../../SeasonPass/constants";
import { toast } from "react-toastify";
import { withRouter } from "react-router-dom";

const EventPaymentMethods = (props) => {
    const [state, setStateInternal] = useState({
        eventId: props.match.params.id,
        currentEvent: {},
        loading: true,
        useDefault: false,
        isDisabled: true,
        administrativeFeePaidByCustomer: true,
        processingFeePaidByCustomer: true,
        paymentMethods: [],
    });
    const setState = (v) => setStateInternal(os => { return { ...os, ...v } });

    const getPaymentMethods = async () => {
        return axios.get(`${getCustomURLs().API_URL}/PaymentMethod/event/${state.eventId}`,
            {
                headers: getHeaders(ls.get('user').token),
            }).then((r) => {
                setState({
                    useDefault: r.data.every(i => !i.isUsedForEvent),
                    paymentMethods: r.data,
                });
            }).catch(() => {
                toast.error('Something went wrong');
                setState({ loading: false });
            });
    }

    const getEventData = async () => {

        return axios.get(`${getCustomURLs().API_URL}/Events/${state.eventId}`,
            {
                headers: getHeaders(ls.get('user').token),
            }).then((r) => {
                const ev = r.data.result;
                setState({
                    currentEvent: ev,
                    administrativeFeePaidByCustomer: ev.administrativeFeePaidByCustomer,
                    processingFeePaidByCustomer: ev.processingFeePaidByCustomer,
                });
            }).catch(() => {
                toast.error('Something went wrong');
                setState({ loading: false });
            });
    }

    const savePaymentMethods = () => {
        axios.put(`${getCustomURLs().API_URL}/PaymentMethod/event/${state.eventId}`,
            state.useDefault
                ? []
                : state.paymentMethods.map(m => { return { id: m.id, activated: m.isUsedForEvent } }),
            {
                headers: getHeaders(ls.get('user').token),
            }).then((r) => {
                toast.success('Payments is saved successfully')
            }).catch((e) => {
                toast.error('Payments is not saved');
            });

        axios.put(`${getCustomURLs().API_URL}/PaymentMethod/event/${state.eventId}/customerFee`,
            {
                administrativeFeePaidByCustomer: state.administrativeFeePaidByCustomer,
                processingFeePaidByCustomer: state.processingFeePaidByCustomer,
            },
            {
                headers: getHeaders(ls.get('user').token),
            }).then((r) => {
            }).catch((e) => {
            });
    };

    const changeMethodEventUsing = (v, id) => {
        const method = state.paymentMethods.find(m => m.id === id);

        if (method) {
            method.isUsedForEvent = !method.isUsedForEvent;
            setState({ paymentMethods: state.paymentMethods.map(m => m) });
        }
    }

    const changeMethodUseDefault = (v) => {
        setState({ useDefault: !state.useDefault });
    }

    const changeAdministraitiveFeePaidByCustomer = (v) => {
        setState({ administrativeFeePaidByCustomer: !state.administrativeFeePaidByCustomer });
    }

    const changeProcessingFeePaidByCustomer = (v) => {
        setState({ processingFeePaidByCustomer: !state.processingFeePaidByCustomer });
    }

    const validateInputs = () => {
        const isDisabled = !state.useDefault
            && state.paymentMethods.every(m => !m.isUsedForEvent);

        if (state.isDisabled !== isDisabled) {
            setState({
                isDisabled: isDisabled
            });
        }
    }

    useEffect(() => {
        Promise.all([getPaymentMethods(), getEventData()])
            .then(() => {
                setState({ loading: false })
            })
            .catch(() => {
                setState({ loading: false })
            });
    }, []);

    const {
        loading,
        useDefault,
        paymentMethods,
        administrativeFeePaidByCustomer,
        processingFeePaidByCustomer
    } = state;

    if (loading) {
        return (
            <div className="wallets">
                <NewLoader />
            </div>
        );
    }

    validateInputs();

    return <>

        <section className={styles['container']}>

            <div className={styles['fee-paid-selection']}>
              <span>Administrative fee paid by:</span>

              <label className='radiobutton'>
                <input
                  className='radiobutton__input'
                  name='AdministraitiveFeePaid'
                  type='radio'
                  value='promoter'
                  onChange={(e) => {
                    changeAdministraitiveFeePaidByCustomer(false);
                  }}
                  checked={!administrativeFeePaidByCustomer}
                />
                <span>Promoter</span>
              </label>

              <label className='radiobutton'>
                <input
                  className='radiobutton__input'
                  name='AdministraitiveFeePaid'
                  type='radio'
                  value='customer'
                  onChange={(e) => {
                    changeAdministraitiveFeePaidByCustomer(true);
                  }}
                  checked={administrativeFeePaidByCustomer}
                />
                <span>Customer</span>
              </label>
            </div>

            <div className={styles['fee-paid-selection']}>
              <span>Processing fee paid by:</span>

              <label className='radiobutton'>
                <input
                  className='radiobutton__input'
                  name='ProcessingFeePaidBy'
                  type='radio'
                  value='promoter'
                  onChange={(e) => {
                    changeProcessingFeePaidByCustomer(false);
                  }}
                  checked={!processingFeePaidByCustomer}
                />
                <span>Promoter</span>
              </label>

              <label className='radiobutton'>
                <input
                  className='radiobutton__input'
                  name='ProcessingFeePaidBy'
                  type='radio'
                  value='customer'
                  onChange={(e) => {
                    changeProcessingFeePaidByCustomer(true);
                  }}
                  checked={processingFeePaidByCustomer}
                />
                <span>Customer</span>
              </label>
            </div>

            <CheckBox
                name="change-default"
                id={`change-default_${0}`}
                checked={useDefault}
                onChange={v => changeMethodUseDefault(v.target.checked)}>
                Use promoter default
            </CheckBox>

            <div disabled className={`${styles['paymentMethodsContainer']} ${useDefault && styles['disabled']}`}>
                {paymentMethods.map(m =>
                    <div key={m.id} className={styles['item']}>
                        <strong>Payment provider: {paymentProvidersOptions.find(i => i.id === m.provider).label}</strong>

                        <div className="add-event__block" style={{ marginBottom: 0 }}>
                            <label>Name</label>
                            <span>{m.paymentMethodName}</span>
                        </div>

                        <div>
                            <CheckBox
                                name="change-default"
                                id={`change-default_${m.id}`}
                                checked={useDefault ? m.isPromoterDefault : m.isUsedForEvent}
                                onChange={v => changeMethodEventUsing(v.target.checked, m.id)}>
                                Use for event
                            </CheckBox>


                        </div>
                    </div>)}
            </div>

            <div className={styles['footer']}>

                <button
                    type="button"
                    className={`btn-primary-new admin ${styles['button']}`}
                    onClick={() => savePaymentMethods()}
                    disabled={state.isDisabled}
                >
                    Save
                </button>

            </div>

        </section>
    </>
}

const mapStateToProps = (props) => ({ ...props });

const mapDispatchToProps = (dispatch) => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(EventPaymentMethods));